function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es6.number.constructor.js";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.array.map.js";
import "core-js/modules/es6.regexp.search.js";
import "core-js/modules/es7.promise.finally.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.array.reduce.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/es6.array.slice.js";
import "core-js/modules/es6.array.for-each.js";
import "core-js/modules/es6.array.find-index.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.object.define-property.js";
import "core-js/modules/es6.object.get-own-property-descriptor.js";
import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.object.define-properties.js";
import "core-js/modules/es6.string.iterator.js";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/web.dom.iterable.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import ApiService from '../../../../services/apiService';
import { mapState, mapGetters } from 'vuex';
import moment from 'moment';
import get from 'lodash/get';
import debounce from 'lodash/debounce';
import { codemirror } from 'vue-codemirror';
import 'codemirror/lib/codemirror.css';
import 'codemirror/theme/base16-dark.css';
import 'codemirror/theme/duotone-light.css';
import 'codemirror/mode/javascript/javascript.js';
import { userItemsPerListMixin } from '@/utils/vuex';
import chartMixin from '@/components/niotaClassic/charts/chartMixin';
import stateHistoryFetchMixin from '@/mixins/stateHistoryFetch';
var defaultItemsPerPage = 10;
var defaultTableOptions = {
  sortBy: ['time'],
  sortDesc: [true],
  page: 1,
  itemsPerPage: defaultItemsPerPage
};
export default {
  name: 'CoreDtwinStateHistory',
  components: {
    codemirror: codemirror
  },
  mixins: [userItemsPerListMixin, chartMixin, stateHistoryFetchMixin],
  props: {
    state: {
      type: Object,
      required: true
    },
    minYAxis: {
      type: Number,
      required: false,
      "default": null
    },
    maxYAxis: {
      type: Number,
      required: false,
      "default": null
    }
  },
  data: function data() {
    return {
      packetHistory: [],
      packetAggHistory: [],
      isLoadingTable: false,
      isLoadingChart: false,
      hasChartError: false,
      hasTableError: false,
      chartLinesCurved: true,
      chartOmitNull: true,
      queryStartDate: new Date(new Date() - 86400000),
      queryEndDate: new Date(),
      customDatePicked: false,
      serverItemsLength: -1,
      tableOptions: _objectSpread({}, defaultTableOptions),
      priorTableOptions: {},
      expandedEvent: [],
      tableFooterProps: {
        itemsPerPageText: this.$i18n_t('Common.rowsPerPage'),
        itemsPerPageOptions: [10, defaultTableOptions.itemsPerPage, 20, 50]
      },
      cmOptions: {
        tabSize: 4,
        mode: 'application/ld+json',
        theme: this.$store.state.app.UiTheme ? 'base16-dark' : 'duotone-light',
        lineNumbers: false,
        line: true,
        foldGutter: true,
        styleActiveLine: true,
        styleSelectedText: true,
        readOnly: true,
        hintOptions: {
          completeSingle: false
        },
        lineWrapping: true,
        viewportMargin: Infinity
      },
      tabs: null,
      interval: '1h',
      // chart fetch options
      min: false,
      max: false,
      average: true,
      latest: false,
      // do not aggregate anything, but output the latest value of a time-interval
      rawData: false,
      // return the latest 50 raw values (unaggregated)

      chartData: {
        data: []
      }
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color'])), mapGetters({
    sessionUserId: 'authentication/userId'
  })), {}, {
    stateIsNumber: function stateIsNumber() {
      return this.state.properties.valueType === 'number';
    },
    chartConfig: function chartConfig() {
      return _objectSpread(_objectSpread({}, this.chartLinesCurved ? {} : {
        elements: {
          line: {
            tension: 0
          }
        }
      }), this.chartOmitNull ? {} : {
        spanGaps: true
      });
    },
    isEmptyChart: function isEmptyChart() {
      return !this.isLoadingChart && !this.hasChartError && (this.chartData.data.avg || []).length === 0 && (this.chartData.data.min || []).length === 0 && (this.chartData.data.max || []).length === 0 && (this.chartData.data.latest || []).length === 0 && (this.chartData.data.rawData || []).length === 0;
    },
    items: function items() {
      return [{
        time: '5min',
        timeVal: '5m',
        disabled: false
      }, {
        time: '15min',
        timeVal: '15m',
        disabled: false
      }, {
        time: '1h',
        timeVal: '1h',
        disabled: false
      }, {
        time: "1 ".concat(this.$i18n_t('Common.day')),
        timeVal: '1d',
        disabled: false
      }, {
        time: "1 ".concat(this.$i18n_t('Common.week')),
        timeVal: '1w',
        disabled: false
      }];
    },
    tableHeaders: function tableHeaders() {
      return [{
        sortable: true,
        text: this.$i18n_t('Core.DateTimePicker.dateTime'),
        value: 'time'
      }, {
        sortable: true,
        text: "".concat(get(this.state, 'properties.title', this.state.key), " ").concat(get(this.state, 'properties.unit', '')),
        value: 'value'
      }, {
        text: '',
        value: 'data-table-expand'
      }];
    }
  }),
  watch: {
    tableOptions: {
      handler: function handler() {
        this.loadTableData();
      },
      deep: true
    },
    queryItemsInflux: debounce(function () {
      this.loadTableData();
      this.loadChartData();
    }, 500, {
      leading: true
    }),
    state: {
      handler: function handler() {
        this.loadTableData();
        this.loadChartData();
      },
      deep: true
    },
    interval: {
      handler: function handler() {
        this.loadChartData();
      }
    },
    average: {
      handler: function handler() {
        this.loadChartData();
      }
    },
    min: {
      handler: function handler() {
        this.loadChartData();
      }
    },
    max: {
      handler: function handler() {
        this.loadChartData();
      }
    },
    latest: {
      handler: function handler() {
        this.loadChartData();
      }
    },
    rawData: {
      handler: function handler() {
        var _this = this;
        if (this.rawData) {
          this.min = false;
          this.max = false;
          this.average = false;
          this.latest = false;
        }
        // if disabled again, enable at least 1 option by default again
        if (!this.rawData) {
          var options = ['min', 'max', 'average', 'latest'];
          // check if OTHER options are selected as well
          if (options.map(function (o) {
            return _this[o];
          }).filter(function (o) {
            return o;
          }).length === 0) {
            this.average = true;
          }
        }
        this.loadChartData();
      }
    }
    // historyRangeStartDate() {
    //   this.queryStartDate = new Date(this.historyRangeStartDate);
    // },
    // historyRangeEndDate() {
    //   this.queryEndDate = new Date(this.historyRangeEndDate);
    // },
  },
  created: function created() {
    defaultTableOptions.itemsPerPage = this.savedUserItemsPerList();
    var page = parseInt(this.$route.query.page, 10) || defaultTableOptions.page;
    var perPage = parseInt(this.$route.query.perPage, 10) || defaultTableOptions.itemsPerPage;
    var search = this.$route.query.search || '';
    if (search) {
      this.isInitialSearch = true;
      this.searchItem = search;
    }
    this.tableOptions.page = page;
    this.tableOptions.itemsPerPage = perPage;
  },
  mounted: function mounted() {
    // this.queryStartDate = new Date(this.historyRangeStartDate ? this.historyRangeStartDate : new Date() - 86400000);
    // this.queryEndDate = new Date(this.historyRangeEndDate ? this.historyRangeEndDate : new Date());
    this.disableTimeIntervals(this.queryEndDate, this.queryStartDate);
    this.loadTableData();
    this.loadChartData();
  },
  methods: {
    shouldOptionCheckboxBeDisabled: function shouldOptionCheckboxBeDisabled(option) {
      var _this2 = this;
      if (option !== 'rawData' && this.rawData) {
        return true;
      }
      if (option === 'rawData') {
        // always allow the "rawData" checkbox, see handler that will disable all other options on selection
        return false;
      }
      var options = ['min', 'max', 'average', 'latest'].filter(function (o) {
        return o !== option;
      });
      // check if OTHER options are selected as well
      return options.map(function (o) {
        return _this2[o];
      }).filter(function (o) {
        return o;
      }).length === 0;
    },
    reloadData: function reloadData() {
      if (!this.customDatePicked) {
        this.queryEndDate = new Date();
      }
      // NOTE: this is triggered externally if the history was updated.
      this.loadTableData();
      this.loadChartData();
    },
    loadChartData: function loadChartData() {
      var _this3 = this;
      if (!this.stateIsNumber) {
        this.isLoadingChart = false;
        return [];
      }
      if (this.isLoadingChart) {
        return;
      }
      this.isLoadingChart = true;
      this.hasChartError = false;
      var extraParams = {
        interval: this.interval,
        min: this.min,
        max: this.max,
        latest: this.latest,
        rawData: this.rawData
      };
      ApiService.influxStatesSearchAggregated(this, [this.state.dtwinId], [this.state.id], {}, this.queryStartDate, this.queryEndDate, 'avg', extraParams).then(function (chartResponse) {
        // normalize API response to consistent format { avg: [], min: [], max: [] }
        var normalized = chartResponse;
        var hasDataWithTooManyItems = false;

        // convert all data values to fixed decimal places
        var chartData = Object.keys(normalized).reduce(function (acc, key) {
          var normedData = normalized[key].map(function (item) {
            return {
              time: item.time,
              value: typeof item.value === 'number' ? parseFloat(item.value.toFixed(4)) : _this3.state.properties.valueType === 'boolean' && item.value === null ? 0 : item.value
            };
          });
          // sort data descendingly
          // if there are too many datapoints, this will show the newest one first and cut off old data
          // since the chart-lib seems to only be able to display ~1000 entries
          // https://digimondo.atlassian.net/browse/RD-6253?focusedCommentId=40677
          normedData = normedData.reverse();
          if (normedData.length > 1000) {
            hasDataWithTooManyItems = true;
          }
          return _objectSpread(_objectSpread({}, acc), {}, _defineProperty({}, key, normedData));
        }, {});

        // set main label for chart based on stat title and unit
        _this3.chartData.label = "".concat(_this3.state.properties.title);
        if (_this3.state.properties.unit) {
          _this3.chartData.label += " (".concat(_this3.state.properties.unit, ")");
        }

        // set chart data
        _this3.chartData.data = _objectSpread(_objectSpread(_objectSpread(_objectSpread(_objectSpread({}, _this3.average ? {
          avg: chartData.avg.slice(0, 1000)
        } : {}), _this3.max ? {
          max: (chartData.max || []).slice(0, 1000)
        } : {}), _this3.min ? {
          min: (chartData.min || []).slice(0, 1000)
        } : {}), _this3.latest ? {
          latest: (chartData.latest || []).slice(0, 1000)
        } : {}), _this3.rawData ? {
          rawData: (chartData.rawData || []).slice(0, 1000)
        } : {});
        _this3.chartData.hasDataWithTooManyItems = hasDataWithTooManyItems;
      })["catch"](function (error) {
        console.error(error);
        _this3.hasChartError = true;
      })["finally"](function () {
        _this3.isLoadingChart = false;
      });
    },
    loadTableData: function loadTableData() {
      var _this4 = this;
      if (this.isLoadingTable) {
        return;
      }
      this.isLoadingTable = true;
      this.hasTableError = false;
      var _this$tableOptions = this.tableOptions,
        sortBy = _this$tableOptions.sortBy,
        sortDesc = _this$tableOptions.sortDesc,
        page = _this$tableOptions.page,
        itemsPerPage = _this$tableOptions.itemsPerPage;
      var sortItem = sortBy && sortBy.length ? sortBy[0] : 'time';
      var doSortDesc = sortDesc && sortDesc.length ? sortDesc[0] : true;
      var sortDirection = doSortDesc ? 'DESC' : 'ASC';
      var usedPage = page ? page - 1 : 0;
      var usedItemsPerPage = itemsPerPage || defaultItemsPerPage;
      this.loadDetailledHistoryData(this.state.id, this.state.dtwinId, sortItem, sortDirection, usedPage, usedItemsPerPage).then(function (res) {
        _this4.serverItemsLength = res.totalCount;
        _this4.packetHistory = res.items.map(function (item, index) {
          return _objectSpread({
            id: "".concat(usedPage, "-").concat(index + 1)
          }, item);
        });
      })["catch"](function (error) {
        console.error(error);
        _this4.hasTableError = true;
      })["finally"](function () {
        _this4.isLoadingTable = false;
      });
    },
    outputValue: function outputValue(value) {
      if (value === null) {
        return 'null';
      }
      try {
        var jsonObject = _typeof(value) === 'object' ? value : JSON.parse(value);
        // parse and then stringify again to get a nice format
        return JSON.stringify(jsonObject, null, 1);
      } catch (error) {
        // on error we return outside of try/catch
      }
      return value;
    },
    localizeDate: function localizeDate(a) {
      if (a) {
        moment.locale(this.$store.state.app.language || window.navigator.userLanguage || window.navigator.language);
        return moment(a).format('L LTS');
      }
      return '-';
    },
    handleDatePicked: function handleDatePicked(dateObject) {
      this.queryStartDate = new Date(dateObject.from * 1000);
      this.queryEndDate = new Date(dateObject.to * 1000);
      // NOTE: for the "reloadData" event, make sure that the end-date is always up-to-date
      // so refresh it automatically if it is "close enough"
      this.customDatePicked = Math.abs(this.queryEndDate - new Date()) > 60000;
      this.disableTimeIntervals(this.queryEndDate, this.queryStartDate);
      //Set current table page to the first one
      this.tableOptions.page = 1;
    },
    disableTimeIntervals: function disableTimeIntervals(endDate, startDate) {
      var _this5 = this;
      var diffInMils = new Date(endDate) - new Date(startDate);
      var diffInMins = Math.floor(diffInMils / 60000);
      var diffInDays = diffInMils / (1000 * 60 * 60 * 24);
      this.items.forEach(function (item) {
        item.disabled = false;
      });
      if (diffInDays > 30) {
        // disable first three options
        this.items[0].disabled = true;
        this.items[1].disabled = true;
        this.items[2].disabled = true;
        this.interval = '1d';
      } else if (diffInDays < 30) {
        var durationsInMins = [5, 15, 60, 1440, 10080, 43200];
        var upperBoundDurationIndex = durationsInMins.findIndex(function (x) {
          return diffInMins < x;
        });
        // if smaller or equal to 5 then [5], otherwise the upperBoundDurationIndex.
        // example1: upperBoundDuration is 60 -> index: 2, then allowed is index 2
        var maximumAllowedDurationIndex = upperBoundDurationIndex ? upperBoundDurationIndex : 1;
        // follow example 1: allowedDurations = ['5m', '15m']
        this.items.forEach(function (item, itemIndex) {
          if (itemIndex >= maximumAllowedDurationIndex) {
            item.disabled = true;
          }
        });

        // use the minimum between max allowed and stored interval
        // if max allowed is 1h and stored interval is 15m, then use 15m
        // if max allowed is 1h and stored interval is 1d, then use 1h
        var currentIntervalIndex = this.items.findIndex(function (x) {
          return x.timeVal === _this5.interval;
        });
        this.interval = this.items[Math.min(currentIntervalIndex, maximumAllowedDurationIndex - 1)].timeVal;
      }
    },
    setCurrentTablePage: function setCurrentTablePage(value) {
      this.tableOptions.page = value;
    }
  }
};